import { Routes } from '@angular/router';
import { AuthenticationGuard } from './modules/auth/services/authentication-guard';

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    canActivate: [AuthenticationGuard],
    loadChildren: () => import('./layout/panel.routes').then(m => m.PANEL_ROUTES)
  },
  {
    path: 'auth',
    // canActivate: [AuthenticationGuard],
    loadChildren: () => import('./modules/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  // {
  //   path: 'calendar', component: FilemanagerComponent,
  // },
  { path: '**', redirectTo: '' }
];

